import { useContext } from 'react';
import { SchemasContext } from '../layers/SchemasLayer';
import { Schema } from '../types/segment.types';

const useSchemas = (): { [id: string]: Schema } | undefined => {
  return useContext(SchemasContext);
};

export default useSchemas;
